import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "h-full w-full overflow-hidden",
  id: "mainDivInAppVue",
  ref: "mainDivInAppVue"
}
const _hoisted_2 = {
  "aria-live": "assertive",
  class: "fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-50"
}
const _hoisted_3 = { class: "w-full flex flex-col items-center space-y-4 sm:items-end" }
const _hoisted_4 = {
  key: 0,
  class: "w-1.5 bg-green-700 flex px-2 sm:px-4"
}
const _hoisted_5 = {
  key: 1,
  class: "bg-rose-700 flex px-2 sm:px-4"
}
const _hoisted_6 = {
  key: 2,
  class: "bg-sky-700 flex px-2 sm:px-4"
}
const _hoisted_7 = {
  key: 3,
  class: "bg-yellow-700 flex px-2 sm:px-4"
}
const _hoisted_8 = { class: "pl-2.5 p-4 flex-1" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "ml-3 w-0 flex-1 pt-0.5" }
const _hoisted_11 = { class: "text-sm sm:text-base font-bold text-gray-900" }
const _hoisted_12 = { class: "mt-1 text-sm sm:text-base leading-tight sm:leading-tight text-gray-700" }
const _hoisted_13 = { class: "ml-4 flex-shrink-0 flex pointer-events-auto" }
const _hoisted_14 = ["onMousedownCapture"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_ExclamationIcon = _resolveComponent("ExclamationIcon")!
  const _component_InformationCircleIcon = _resolveComponent("InformationCircleIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_TransitionGroup, {
          "enter-active-class": "transform ease-out duration-300 transition",
          "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-72 sm:scale-150 sm:rotate-12",
          "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
          "leave-active-class": "transition ease-in duration-300",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "max-w-sm w-full rounded-lg ring-1 ring-black ring-opacity-5 overflow-hidden bg-white flex shadow-xl"
              }, [
                (item.type === _ctx.NotificationItemType.Success)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_CheckCircleIcon, {
                        class: "h-6 w-6 sm:h-8 sm:w-8 self-center text-green-50",
                        "aria-hidden": "true"
                      })
                    ]))
                  : (item.type === _ctx.NotificationItemType.Error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_ExclamationIcon, {
                          class: "h-6 w-6 sm:h-8 sm:w-8 self-center text-rose-50",
                          "aria-hidden": "true"
                        })
                      ]))
                    : (item.type === _ctx.NotificationItemType.Info)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_InformationCircleIcon, {
                            class: "h-6 w-6 sm:h-8 sm:w-8 self-center text-sky-50",
                            "aria-hidden": "true"
                          })
                        ]))
                      : (item.type === _ctx.NotificationItemType.Warning)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_ExclamationIcon, {
                              class: "h-6 w-6 sm:h-8 sm:w-8 self-center text-yellow-50",
                              "aria-hidden": "true"
                            })
                          ]))
                        : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(item.title), 1),
                      _createElementVNode("p", _hoisted_12, _toDisplayString(item.text), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        onMousedownCapture: _withModifiers(($event: any) => (_ctx.closeNotificationItem(item.id)), ["stop"]),
                        class: "bg-white rounded-md inline-flex text-gray-400 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                      }, [
                        _hoisted_15,
                        _createVNode(_component_XIcon, {
                          class: "h-5 w-5",
                          "aria-hidden": "true"
                        })
                      ], 40, _hoisted_14)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}